import { queryOptions } from '@tanstack/react-query';
import type { ListOccurrencesQuery } from '@klopotun/contracts';
import { occurrenceQueryRoot } from '../../../../shared/api/index.js';
import { getOccurrence } from '../requests/get-occurrence.js';
import { getOccurrences } from '../requests/get-occurrences.js';

/**
 * An empty filter is not "every period": design note C12 makes the server answer a filterless
 * request with the planned ones from today to the materialisation horizon.
 */
const PLANNED_TO_HORIZON: ListOccurrencesQuery = {};

export const occurrenceQueries = {
  ...occurrenceQueryRoot,
  list: (query: ListOccurrencesQuery = PLANNED_TO_HORIZON) =>
    queryOptions({
      queryKey: [...occurrenceQueryRoot.lists(), query] as const,
      queryFn: ({ signal }) => getOccurrences(query, signal),
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: [...occurrenceQueryRoot.details(), id] as const,
      queryFn: ({ signal }) => getOccurrence(id, signal),
    }),
};
